import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './NoLogo.css';

export function NoLogo(): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <IconFunctionalHouse16 color="icon-secondary-default" />
    </div>
  );
}
